import CategoryLauncher from "@/components/CategoryLauncher.vue";
import { strippedCta } from "@/helpers/builder-init/index";
export const categoryLauncherInit = {
    component: CategoryLauncher,
    name: "CategoryLauncher",
    canHaveChildren: true,
    inputs: [
        {
            name: "togglePadding",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "textBelow",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "columns",
            type: "string",
            defaultValue: "four",
            enum: ["two", "three", "four"]
        },
        {
            name: "categories",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "headline",
                    type: "string"
                },
                {
                    name: "image",
                    type: "file",
                    helperText:
                        "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"]
                },
                {
                    name: "image_alt",
                    type: "string"
                },
                {
                    name: 'cta',
                    type: 'object',
                    subFields: strippedCta(['url', 'aria_label', 'label', ]).subFields
                }
            ]
        }
    ]
};
